import CampaignDetailsPage from "../../../components/Pages/Campaign/Details/Details";

const CampaignDetails = () => {
  return (
    <div>
      <CampaignDetailsPage />
    </div>
  );
};

export default CampaignDetails;
